import { useEffect } from "react";
import Flexbox from "../components/Flexbox";
import Spacebox from "../components/Spacebox";
import '../css/form.css'
import { useDispatch } from "react-redux";
import cookies from "../utilities/Cookies";
import { updatedarkmode } from "../features/mode";
import Mode from "../components/styles/Mode";

const VssDisqualify = () => {

    const dispatch = useDispatch()


    useEffect(() => {
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))
        // eslint-disable-next-line
    }, [])

    return (
        <Mode>
            <div className="dq-page" style={{ background: 'white' }}>
                {<div className="margin-auto error-div">
                    <div style={{ textAlign: 'center', padding: 20 }}>
                        <Spacebox padding="20px" />
                        <Flexbox alignItems="center" justifyContent="center">
                            <img src="/assets/color-logo.png" alt="Final debt relief" style={{ width: 200 }} />
                        </Flexbox>
                        <Spacebox padding="10px" />
                        <Flexbox justifyContent="space-between" alignItems="center">
                            <div>
                                
                            </div>
                        </Flexbox>
                        <Spacebox padding="20px" />
                        <div className="margin-auto" style={{ textAlign: 'center', maxWidth: 500 }}>
                            <div style={{ width: 'fit-content' }} className="margin-auto">
                                <img src="/assets/green-check.png" alt="check" style={{ width: 40 }} />
                            </div>
                            <Spacebox padding="20px" />
                            <span style={{ fontSize: 25, fontWeight: 600 }} className="trade-green">
                                Thank you for your application. 
                            </span>
                            <Spacebox padding="10px" />
                            <span>
                                Because you are already enrolled in a debt relief program, you do not qualify for a new enrollment with Final Debt Relief today. To avoid conflicting with your current negotiations, please stay the course with your existing provider.
                            </span>
                            <Spacebox padding="20px" />
                        </div>
                    </div>
                </div>}
            </div>
        </Mode>
    );
}

export default VssDisqualify;